<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && statusFrete">
      <div class="mt-3">
        <div class="d-inline-block">
          <v-img class="logo-transportadora"
                 :src="statusFrete.frete.picture"/>
        </div>
        <div class="d-inline-block ml-3">
          ({{ statusFrete.frete.name }}) <small>#{{ pacote.id }}</small>
        </div>
        <div class="d-inline-block" v-if="statusFrete">
          <px-compra-pacote-frete-melhor-envio-actions :pacote="pacote"
                                                       :compra="compra"
                                                       :status-frete="statusFrete"
                                                       @change="onChangePacote"/>
        </div>
      </div>
      <div class="mt-3">
        Veja abaixo como você deve fazer a separação dos pacotes:
      </div>
      <div v-for="(track, index) in statusFrete.tracking" :key="track.id" class="mt-3">
        <v-subheader class="text--primary grey-subheader">
          <v-row>
            <v-col cols="6">
              <v-icon>mdi-package-variant</v-icon>
              Remessa #{{ index + 1 }}
            </v-col>
            <v-col cols="6" class="text-right">
              <px-situacao-composicao-pacote small :situacao="track.situacao"/>
              <v-btn small
                     class="normal-btn-text rounded-tag-small elevation-0 ml-3"
                     :disabled="isPacotePendente(track)"
                     :href="linkRastreio(track)"
                     target="_blank">
                Rastrear
                <v-icon right small>mdi-open-in-new</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-subheader>
        <div v-for="(composicao, idxCaixa) in track.composicao" :key="composicao.id">
          <v-row>
            <v-col cols="12" sm="2" class="d-flex align-center">
              <span class="caption font-weight-bold">Caixa #{{ idxCaixa + 1 }}</span>
            </v-col>
            <v-col cols="12" sm="3">
              <span class="caption font-weight-bold">Peso</span>
              <div>
                {{ composicao.dimensoes.peso | number('0.0') }} kg
              </div>
            </v-col>
            <v-col cols="12" sm="3">
              <span class="caption font-weight-bold">Comprimento</span>
              <div>
                {{ composicao.dimensoes.comprimento }} cm
              </div>
            </v-col>
            <v-col cols="12" sm="2">
              <span class="caption font-weight-bold">Largura</span>
              <div>
                {{ composicao.dimensoes.largura }} cm
              </div>
            </v-col>
            <v-col cols="12" sm="2">
              <span class="caption font-weight-bold">Altura</span>
              <div>
                {{ composicao.dimensoes.altura }} cm
              </div>
            </v-col>
          </v-row>
          <div class="mt-3">
            <v-list>
              <v-list-item>
                <v-list-item-content class="list-item-oferta-title">
                  <span class="body-2 font-weight-bold">Produto</span>
                </v-list-item-content>
                <v-list-item-content>
                  <span class="body-2 font-weight-bold">Quantidade na caixa</span>
                </v-list-item-content>
                <v-list-item-action>
                </v-list-item-action>
              </v-list-item>
              <v-list-item v-for="ofertaPacote in composicao.ofertasPacotes"
                           :key="ofertaPacote.id">
                <v-list-item-avatar class="square-avatar">
                  <px-oferta-foto height="40"
                                  width="40"
                                  :foto="ofertaPacote.oferta.oferta.foto"/>
                </v-list-item-avatar>
                <v-list-item-content class="list-item-oferta-title">
                  <span class="body-1">
                    <px-codigo-interno :codigo-interno="ofertaPacote.oferta.oferta.codigoInterno"/>
                    {{ ofertaPacote.oferta.tituloProduto }}
                  </span>
                  <div>
                    <px-show-variacoes-completo :variacoes="ofertaPacote.oferta.variacoes"/>
                  </div>
                </v-list-item-content>
                <v-list-item-content>
                <span class="body-2">
                  {{ ofertaPacote.quantidade }} {{ ofertaPacote.oferta.unidadeMedida.descricao }}
                </span>
                </v-list-item-content>
                <v-list-item-action>
                  <px-open-oferta is-marketplace :oferta="ofertaPacote.oferta.oferta"/>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SituacaoComposicaoPacote } from 'px-business-components';
import ComprasService from '@/modules/marketplace/compras/compras-service';
import CompraPacoteFreteMelhorEnvioActions
  from '@/modules/marketplace/compras/detalhes/CompraPacoteFreteMelhorEnvioActions.vue';

const MELHOR_ENVIO_RASTREIO = 'https://app.melhorrastreio.com.br/app/melhorenvio/';

export default {
  props: {
    pacote: {
      type: Object,
      required: true,
    },
    compra: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      statusFrete: null,
    };
  },
  computed: {
    isPacotePendente() {
      return (pacote) => [SituacaoComposicaoPacote.keys.PENDENTE.key,
        SituacaoComposicaoPacote.keys.AGUARDANDO_APROVACAO.key].includes(pacote.situacao);
    },
    linkRastreio() {
      return (pacote) => `${MELHOR_ENVIO_RASTREIO}${pacote.protocol}`;
    },
  },
  methods: {
    getStatusFrete() {
      this.loading = true;
      ComprasService.getStatusFrete(this.pacote.id)
        .then(({ data }) => {
          this.statusFrete = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangePacote() {
      this.$emit('change');
    },
  },
  created() {
    this.getStatusFrete();
  },
  components: {
    pxCompraPacoteFreteMelhorEnvioActions: CompraPacoteFreteMelhorEnvioActions,
  },
};
</script>


<style scoped>
.list-item-oferta-title {
  min-width: 35%;
}
</style>
